const appBaseUrl = process.env.NEXT_PUBLIC_WS_EXT_APP_BASE_URL

/**
 * Return a URL to the survey app.
 */
export const appUrl = (relativePath: string): string =>
  `${appBaseUrl}${relativePath}`
